import { createContext, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';

const MainContext = createContext();

const MainContextProvider = props => {
    const [user, setUser] = useState(null)
    const [justLoaded, setJustLoaded] = useState(true)
    const justLoadedRef = useRef(true)
    const alreadyNavigated = useRef(false)
    const pathRef = useRef('/portal')
    const history = useLocation()
    const navigate = useNavigate()
    const [skuDataList, setSkuDataList] = useState({});
    const [asinDataList, setAsinDataList] = useState({});
    const [skuListingManagers, setSkuListingManagers] = useState({});

    //Check for user on page load
    //Also capture target url to redirect properly 
    useEffect(() => {
        if (justLoadedRef.current === true && !user) {
            const { pathname } = history
            pathRef.current = pathname
            justLoadedRef.current = false
            axios.get('/currentUser')
                .then(res => {
                    setUser(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => {
                    setJustLoaded(false)
                })
        }

    }, [justLoadedRef, user, history])

    //If user is present grab all current skulist and listing manager/sku association information for sku search and select throughout tools. 
    useEffect(() => {
        if (user) {
            axios.get('/data/skuStuff')
                .then(({ data }) => {
                    const { asinList, skuList, skuListingManagers: lmList } = data
                    setAsinDataList(asinList)
                    setSkuDataList(skuList)
                    setSkuListingManagers(lmList)
                })
                .catch(err => console.log(err))
        }
    }, [user])


    //Record current url path as user is navigating website before login to correctly forward then when logging in
    //Without this if user starts on landing and logs in they will be sent back to landing instead of app dashboard
    useEffect(() => {
        if (!alreadyNavigated.current && !justLoaded && !user) {
            pathRef.current = history.pathname
        }
    }, [history.pathname, justLoaded, alreadyNavigated, user])


    //After a user has logged in the "user" state will change and navigate the user to the last path they tried to visit
    //This allows the user to refresh on a specific part of the tool and be navigated back to it after the user state is checked
    useEffect(() => {
        if (!alreadyNavigated.current && !justLoaded && user) {
            console.log('NAVIGATING TO: ', pathRef.current)
            navigate(pathRef.current)
            alreadyNavigated.current = true
        }
    }, [justLoaded, user, pathRef, alreadyNavigated, navigate])


    return (
        <MainContext.Provider value={{
            user,
            setUser,
            justLoaded,
            setJustLoaded,
            skuDataList,
            asinDataList,
            skuListingManagers
        }}>
            {props.children}
        </MainContext.Provider>
    )
}



export {
    MainContext,
    MainContextProvider
}